/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
import _ from 'lodash';
import moment from 'moment';

import Person from './Person';

const nameConfig = {
    formatMode: 'default',
    mode: 'default',
    visibleFields: ['Suffix', 'FirstName', 'Prefix', 'LastName', 'Middlename', 'Name']
};

function append(sb, fieldId, value) {
    if (!_.isEmpty(value) && _.includes(nameConfig.visibleFields, fieldId)) {
        sb.push(value);
    }
}

function format(person, delimiter) {
    const lastName = person.lastNameKanji || person.lastName;
    const firstName = person.firstNameKanji || person.firstName;
    const middleName = person.middleName || '';
    const result = [];
    switch (nameConfig.formatMode) {
        case 'default':
            append(result, 'FirstName', firstName);
            append(result, 'MiddleName', middleName);
            append(result, 'LastName', lastName);
            break;
        case 'France':
            append(result, 'LastName', lastName);
            append(result, 'FirstName', firstName);
            break;
        case 'Japan':
            append(result, 'LastName', lastName);
            append(result, 'FirstName', firstName);
            break;
        case 'China':
            append(result, 'LastName', lastName);
            append(result, 'FirstName', firstName);
            break;
        default:
            break;
    }
    return result.join(delimiter);
}


function Driver(data) {
    if (data) {
        if (!data.dateOfBirth) {
            data.dateOfBirth = null;
        }
        this.disclosures_ML = data.disclosures_ML ? data.disclosures_ML : {
            accidents: [],
            claims: [],
            violations: []
        };
        this.violations = data.violations || '0';
        this.accidents = data.accidents || '0';

        _.extend(this, data);
    } else {
        this.disclosures_ML = {
            accidents: [],
            claims: [],
            violations: []
        };
        this.violations = '0';
        this.accidents = '0';
    }
}

Driver.prototype.getDisplayName = function (defaultName) {
    if (this.person.firstName === '0streamlinedquote0') {
        return '';
    }
    return this.person.getDisplayName(defaultName);
};

Driver.prototype.getDriverStatesForCountry = (states, countryCode) => {
    return _.filter(states, (state) => {
        const countryConstraint = _.find(state.categories, (constraint) => {
            return _.keys(constraint).indexOf('Country') !== -1;
        });
        if (countryConstraint) {
            return countryConstraint.Country === countryCode;
        }
        return false;
    });
};

Driver.prototype.getDriverAge = function () {
    if (this.dateOfBirth) {
        return moment().diff(moment(this.dateOfBirth), 'year');
    }
    return null;
};

export default Driver;
